import {useDaumPostcodePopup} from "react-daum-postcode";
import React from "react";

interface PropsType {
    onCompleteCallback: (data: { address: string; zipcode: string }) => void;
    disabled?: boolean;
}

export default function DaumPost({onCompleteCallback, disabled}: PropsType) {
    const CURRENT_URL = "https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";
    const open = useDaumPostcodePopup(CURRENT_URL);

    const handleComplete = (data: any) => {
        let fullAddress = data.address;
        let extraAddress = "";

        if (data.addressType === "R") {
            if (data.bname !== "") {
                extraAddress += data.bname;
            }
            if (data.buildingName !== "") {
                extraAddress += extraAddress !== "" ? `, ${data.buildingName}` : data.buildingName;
            }
            fullAddress += extraAddress !== "" ? ` (${extraAddress})` : "";
        }

        if (onCompleteCallback) {
            onCompleteCallback({
                address: fullAddress,
                zipcode: data.zonecode,
            });
        }
    };

    const handleOnClickAddressBtn = (e: React.MouseEvent<HTMLButtonElement>) => {
        open({
            onComplete: handleComplete,
            popupTitle: "우편주소 찾기",
            left: window.screen.width / 2 - 500 / 2,
            top: window.screen.height / 2 - 450 / 2,
        });

        e.preventDefault();
    };

    return (
        <button className="btn btn-info btn_search ms-5px w-100px"
                onClick={handleOnClickAddressBtn}
                disabled={disabled}>
            <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"}
                 alt=""/>
            주소 검색
        </button>)
};
